export var defaultProps = {
    className: '',
    defaultIndex: 0,
    speed: 0.5,
    interval: 3.5,
    autoPlay: false,
    loop: true,
    hasArrows: true,
    hasDots: true,
    step: 1,
    visibleNum: 1,
    iWidth: 427,
    widthUnit: 'px',
    leftIcon: '',
    rightIcon: '',
    onChange: function (index, carousel) { },
};
export var arrowsDefaultProps = {
    className: '',
    canPrev: true,
    canNext: true,
    leftIcon: '',
    rightIcon: '',
    goPrev: function () { },
    goNext: function () { },
};
export var dotsDefaultProps = {
    className: '',
    currIndex: 0,
    goTo: function (index) { },
};
